import { CustomButton } from 'modules/auth/styles'
import { deleteCategory_api } from 'store/apis'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { connect } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import { history } from 'store/store'
import { handleApiError } from 'utils/helpers'
import { ButtonLoader } from 'utils/storageUtils'
import { getTotalItemsCount_action, getCategories_action, toggleDeleteCategoryModal_action } from 'store/actions'

function DeleteCategoryConfirmModal(props) {
  const [isDeleting, set_isDeleting] = useState(false)
  const onDelete = async () => {
    try {
      set_isDeleting(true)
      await deleteCategory_api(props.contents.deletingCategory.uuid)
      props.getCategories()
      props.getTotalItemsCount()
      toast.success(`Category deleted`)
      props.toggleDeleteCategoryModal(false)
      if (props.contents.redirectToHome) {
        history.push('/')
      }
    } catch (error) {
      handleApiError(error)
    }
    set_isDeleting(false)
  }
  return (
    <Modal zIndex={props.fullScreenStatus ? '300000000000' : ''} centered fade={false} size='sm' isOpen={props.contents.showDeleteCategoryConfirm} toggle={() => props.toggleDeleteCategoryModal(false)}>
      <ModalBody className='pt-5 pb-4'>
        <div className='text-center text-danger'>
          <strong>Are you sure you want to delete this category?</strong>
        </div>
        <div className='mt-4 d-flex justify-content-center align-items-center'>
          <CustomButton onClick={onDelete} className='btn-sm black mx-3'>
            Yes, Delete
            {isDeleting && <ButtonLoader />}
          </CustomButton>
          <a
            href='/'
            className='mx-3 text-dark'
            onClick={(e) => {
              e.preventDefault()
              props.toggleDeleteCategoryModal(false)
            }}>
            Cancel
          </a>
        </div>
      </ModalBody>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  contents: state.contents,
  fullScreenStatus: state.contents.isFullScreen
})

const mapDispatchToProps = (dispatch) => ({
  getCategories: () => dispatch(getCategories_action()),
  getTotalItemsCount: () => dispatch(getTotalItemsCount_action()),
  toggleDeleteCategoryModal: (status, item, redirectToHome) => dispatch(toggleDeleteCategoryModal_action(status, item, redirectToHome))
})
export default connect(mapStateToProps, mapDispatchToProps)(DeleteCategoryConfirmModal)
